/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = { appearances: {}, rules: [], tokens: { space: 1 } }
export default theme
